import { CDN_RESOURCE_STG_URL, isUSSite } from './helpers';
import first from 'lodash/first';

export const LANG_INFO = "@FCBH/Lang";

const LANG_PATH = {
  x_default: "",
  en_US: "",
  zh_TW: "/zh-hk",
};

const LOCALE = {
  x_default: "",
  en_US: "en",
  zh_TW: "zh-TW",
  zh_HK: "zh-HK",
};

let locationPath = window.location.href.split('/');
 function setCurrentLanguage() {
    const language = locationPath.includes("zh-hk")? 'zh-TW' : 'en-US';
    setSelectedLanguage(language);
  };

/**
   * Gets the base URL for locale files
   * @returns {string} - The base URL for locale files
   */
function getLocaleBaseURL() {
  // Use CDN URL if available, otherwise fallback to relative path
  if (typeof CDN_RESOURCE_STG_URL !== 'undefined' && CDN_RESOURCE_STG_URL) {
    return `${CDN_RESOURCE_STG_URL}locales/`;
  }
  // Fallback to relative path
  return './locales/';
}

/**
   * Loads the translation file for the specified language.
   * @param {string} lang - The language code (ex: 'en-US').
   * @returns {Promise<Object>} - The translations object.
   */
  export async function loadTranslations(lang = 'en-US') { //console.log("loadTranslations", lang);
    const baseURL = getLocaleBaseURL();
    try {
      const response = await fetch(`${baseURL}${lang}.json`);
      if (!response.ok) {
        throw new Error(`It's not possible to load the language file: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error(error);
      // Fallback para inglês em caso de erro
      const response = await fetch(`${baseURL}en-US.json`);
      return await response.json();
    }
  }

  /**
   * Searches for a translation key in the loaded translations.
   * @param {Object} translations - The object JSON loaded.
   * @param {string} key - The key (ex: "header.nav.home").
   * @returns {string} - The translated text.
   */
  function getTextFromKey(translations, key) {
    // Split the key by dots and navigate the object
    return key.split('.').reduce((obj, k) => {
      return obj && obj[k] !== undefined ? obj[k] : key;
    }, translations);
  }

  export function translateText(key, translations = {}) {
    const language = FCBH.getFromStorage(LANG_INFO) || {lang: 'en-US'};
    //const translations = await loadTranslations(language.lang);
    return getTextFromKey(translations, key);
  }

  export const localePath = () => {
    const language = FCBH.getFromStorage(LANG_INFO) || {lang: 'en-US'};
    return LANG_PATH[language.lang.replace('-', '_')] || '';
  };

  export function getLocale() {
    const language = FCBH.getFromStorage(LANG_INFO) || {lang: 'en-US'};
    return LOCALE[language.lang.replace('-', '_')] || '';
  };

  /**
 * Replace placeholders in a string (ex: {key}) 
 * with the values from an object.
 *
 * @param {string} template A string containing the placeholders.
 * @param {object} data An object where the keys correspond to the placeholders.
 * @returns {string} The formatted string.
 */
 export function formatLocaleMessage(template, data) {
    if (typeof template !== 'string' || !template) {
        return "";
    }
    // A Regex /{([^}]+)}/g procura por:
    // {        - The literal character "{"
    // (        - Starts a capturing group
    //   [^}]+  - Any character that is NOT "}" (1 or more times)
    // )        - Closes the capturing group
    // }        - The literal character "}"
    // g        - "global" flag, to replace all occurrences
    const regex = /{([^}]+)}/g;

    return template.replace(regex, (match, key) => {
        // 'match' is the entire placeholder (ex: "{currency_code}")
        // 'key' is just what was captured (ex: "currency_code")

        // We use hasOwnProperty to ensure the key exists in the object
        // and to allow values like '0', 'false' or 'null'.
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            return data[key];
        }

        // If the key is not found in the 'data' object,
        // return the original placeholder (match).
        return match;
    });
}

export async function initializeLanguageSettings() {
    if (isUSSite()) {
        setSelectedLanguage('en-US');
    } else {
       // const language = FCBH.getFromStorage(LANG_INFO) || {lang: 'en-US'};
       // redirectToSelectedLanguage(language.lang);
       setCurrentLanguage();
    }
    return await loadTranslations(FCBH.getFromStorage(LANG_INFO).lang);
};

function setSelectedLanguage(newLang = 'en-US') {
    const newForm = {
        lang: newLang
    }

    FCBH.saveToStorage(LANG_INFO, newForm);
}

function redirectToSelectedLanguage(newLang = 'en-US') {
    document.querySelectorAll(".w-locales-item").forEach((node, idx) => {
      node.querySelectorAll("a").forEach((child) => {
        const lang = child.getAttribute("hreflang");
        const href = child.getAttribute("href").split("/");
        if (lang === newLang && href.length > 1) {
          child.click();
        }
      });
    });
  }